<template>
  <div>
    <Head :title="__('Dashboard')" />

    <div class="badge__items flex flex-col lg:flex-row gap-5">
        <div class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets'))">
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Total Ticket') }}</span>
                    <span class="number">{{ total_tickets }}</span>
                </div>
            </div>
        </div>

        <div class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'pending'}))">
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Pending') }}</span>
                    <span class="number">{{ pending_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((pending_tickets * 100)/total_tickets) }">
                            {{ parseInt((pending_tickets * 100)/total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="departements === 3 || auth.user.role.slug === 'admin'" class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'assigned'}))">
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Assigned') }}</span>
                    <span class="number">{{ assigned_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((assigned_tickets * 100) / total_tickets) }">
                            {{ parseInt((assigned_tickets * 100) / total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'onprocess'}))">
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('On Process') }}</span>
                    <span class="number">{{ processing_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((processing_tickets * 100)/total_tickets) }">
                            {{ parseInt((processing_tickets * 100)/total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="departements === 3 || auth.user.role.slug === 'admin' || auth.user.role.slug === 'customer'" class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'revisi-assets'}))">
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Revisi Assets') }}</span>
                    <span class="number">{{ revisiassets_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((processing_tickets * 100)/total_tickets) }">
                            {{ parseInt((revisiassets_tickets * 100)/total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="departements === 3 || auth.user.role.slug === 'admin' || auth.user.role.slug === 'customer'" class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'revisi-brief'}))">
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Revisi Brief') }}</span>
                    <span class="number">{{ revisibrief_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((processing_tickets * 100)/total_tickets) }">
                            {{ parseInt((revisibrief_tickets * 100)/total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'closed'}))">
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Ticket Closed') }}</span>
                    <span class="number">{{ closed_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((done_tickets * 100) / total_tickets) }">
                            {{ parseInt((done_tickets * 100) / total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<template>
    <div class="badge__items flex flex-col lg:flex-row gap-5">
        <div 
            v-if="total_tickets" 
            class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" 
            @click="goToLink(this.route('tickets', {'type': 'new'}))"
        >
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('TOTAL ALL TICKETS') }}</span>
                    <span class="number">{{ total_tickets }}</span>
                </div>
            </div>
        </div>

        <div 
            v-if="pending_tickets" 
            class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" 
            @click="goToLink(this.route('tickets', {'status_id': '6'}))"
        >
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('PENDING') }}</span>
                    <span class="number">{{ pending_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((pending_tickets * 100)/total_tickets) }">
                            {{ parseInt((pending_tickets * 100)/total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div 
            v-if="departements === 3 || auth.user.role.slug === 'admin'" 
            class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" 
            @click="goToLink(this.route('tickets', {'type': 'assigned'}))"
        >
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Assigned') }}</span>
                    <span class="number">{{ assigned_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((assigned_tickets * 100) / total_tickets) }">
                            {{ parseInt((assigned_tickets * 100) / total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div 
            v-if="processing_tickets"
            class="badge__item h-32 w-full lg:w-1/4 cursor-pointer"
        >
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Processing') }}</span>
                    <span class="number">{{ processing_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((processing_tickets * 100)/total_tickets) }">
                            {{ parseInt((processing_tickets * 100)/total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div 
            v-if="departements === 3 || auth.user.role.slug === 'admin'" 
            class="badge__item h-32 w-full lg:w-1/4 cursor-pointer"
        >
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Need Review') }}</span>
                    <span class="number">{{ needreview_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((needreview_tickets * 100)/total_tickets) }">
                            {{ parseInt((needreview_tickets * 100) / total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="departements === 3 || auth.user.role.slug === 'admin' || auth.user.role.slug === 'customer'">
            <div 
                v-for="(ticket, index) in [
                    { title: 'On Review', count: onreview_tickets },
                    { title: 'Revisi Assets', count: revisiassets_tickets },
                    { title: 'Revisi Brief', count: revisibrief_tickets }
                ]" 
                :key="index" 
                class="badge__item h-32 w-full lg:w-1/4 cursor-pointer"
            >
                <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                    <div class="badge__info">
                        <span class="title">{{ __(ticket.title) }}</span>
                        <span class="number">{{ ticket.count }}</span>
                    </div>
                    <div class="a__right">
                        <div class="round_circle pr-3 rtl:pl-3">
                            <div class="pie animate" :style="{ '--pie_val': parseInt((ticket.count * 100) / total_tickets) }">
                                {{ parseInt((ticket.count * 100) / total_tickets) || 0 }}%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div 
            v-if="closed_tickets" 
            class="badge__item h-32 w-full lg:w-1/4 cursor-pointer"
        >
            <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                <div class="badge__info">
                    <span class="title">{{ __('Done Tickets') }}</span>
                    <span class="number">{{ closed_tickets }}</span>
                </div>
                <div class="a__right">
                    <div class="round_circle pr-3 rtl:pl-3">
                        <div class="pie animate" :style="{ '--pie_val': parseInt((done_tickets * 100) / total_tickets) }">
                            {{ parseInt((done_tickets * 100) / total_tickets) || 0 }}%
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
    <div class="bg-white shadow rounded-lg p-4 w-full mt-6 sm:mt-8">
        <BarChart
            :labels="top_departments.map(dep => dep.name)"
            :data="top_departments.map(dep => dep.count)"
            title="Ticket By Department"
        />
    </div>

      <div class="response__details mt-8 flex gap-5 flex-col lg:flex-row" v-if="auth.user.role.slug === 'admin' || auth.user.role.slug === 'supervisor'">
          
          <div class="w-full">
              <div class="r__wrapper flex flex-col pl-5 pr-5 pb-5 bg-white items-center rounded-lg shadow-lg rd">
                  <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Top Tier Tiket') }}</h2>
                  <div class="th__info flex flex-col pt-3">
                      <vc-donut
                          background="white" foreground="grey"
                          :size="120" unit="px" :thickness="45"
                          has-legend legend-placement="right"
                          :sections="top_types" :total="100"
                          :start-angle="0" :auto-adjust-text-size="true">
                      </vc-donut>
                  </div>
              </div>
          </div>

         <div class="w-full">
              <div class="r__wrapper flex flex-col pl-5 pb-5 bg-white items-center rounded-lg shadow-lg rd">
                  <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Top Tier Requester') }}</h2>
                  <div class="th__info flex flex-col pt-3">
                      <vc-donut
                          background="white" foreground="grey"
                          :size="120" unit="px" :thickness="45"
                          has-legend legend-placement="right"
                          :sections="top_requester_creators" :total="100"
                          :start-angle="0" :auto-adjust-text-size="true">
                      </vc-donut>
                  </div>
              </div>
          </div>

          <div class="w-full">
              <div class="r__wrapper flex flex-col pl-5 pb-5 bg-white items-center rounded-lg shadow-lg rd">
                  <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Top Tier Assignee') }}</h2>
                  <div class="th__info flex flex-col pt-3">
                      <vc-donut
                          background="white" foreground="grey"
                          :size="120" unit="px" :thickness="45"
                          has-legend legend-placement="right"
                          :sections="top_creators" :total="100"
                          :start-angle="0" :auto-adjust-text-size="true">
                      </vc-donut>
                  </div>
              </div>
          </div>
          
      </div>

      <div class="response__details flex flex-col lg:flex-row mt-8 gap-5" v-if="auth.user.role.slug === 'admin'">
          <div class="flex gap-5 flex-col lg:flex-row lg:w-10/12">
              <div class="w-full">
                  <div class="r__wrapper flex flex-col p-5 bg-white rounded-lg shadow-lg rd">
                      <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Ticket history') }}</h2>
                      <div class="th__info flex">
                          <span class="text-2xl font-bold"> {{ chart_line.this_month }} </span>
                          <span class="pt-2 text-xs pl-1 pr-1">/ {{ __('this month') }}</span>
                          <span class="pt-2 text-xs font-bold pl-2 pr-2">{{ __('last month') }} {{ chart_line.last_month }}</span>
                      </div>
                      <div v-if="months.length" class="flex w-full justify-center c__wrapper ">
                          <div class="c__line flex flex-col w-full items-center gap-3" v-for="cl in months">
                              <span class="cl__b" :style="{ '--cl_value': cl.value }"></span>
                              <span class="cl__n text-xs">{{ cl.month }}</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class=" rd w-full lg:w-2/5">
                  <div class="r__wrapper flex flex-col pl-5 pr-5 pb-5 bg-white rounded-lg shadow-lg rd">
                      <div class="res__info">
                          <span class="title">{{ __('First Response Time') }}</span>
                          <span class="res_avg">{{ __('Average') }}</span>
                          <div class="flex justify-start">
                              <div v-if="firstResponse.length" v-for="(fr, fri) in firstResponse" class="res_time pr-5" :key="fri">
                                  <span class="num">{{ fr[0] }}</span>
                                  <span class="text">{{ __(fr[1]) }}</span>
                              </div>
                              <div v-else class="res_time pr-5">
                                  0
                              </div>
                          </div>
                      </div>
                      <div class="tc__info">
                          <span class="title">{{ __('Last Response Time') }}</span>
                          <span class="res_avg">{{ __('Average') }}</span>
                          <div class="flex justify-start">
                              <div v-if="lastResponse.length" v-for="(fr, fri) in lastResponse" class="res_time pr-5" :key="fri">
                                  <span class="num">{{ fr[0] }}</span>
                                  <span class="text">{{ __(fr[1]) }}</span>
                              </div>
                              <div v-else class="res_time pr-5">
                                  0
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="flex gap-5 flex-col lg:w-2/12">
              <div class="badge__item h-32 w-full cursor-pointer" @click="goToLink(this.route('users'))">
                  <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                      <div class="badge__info">
                          <span class="title">{{ __('Customers') }}</span>
                          <span class="number">{{ total_customer }}</span>
                      </div>
                      <div class="a__right">
                          <icon name="pending_users" class="h-5 fill-gray-400 mr-5 ml-5" />
                      </div>
                  </div>
              </div>
              <div class="badge__item h-32 w-full cursor-pointer" @click="goToLink(this.route('contacts'))">
                  <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                      <div class="badge__info">
                          <span class="title">{{ __('Contacts') }}</span>
                          <span class="number">{{ total_contacts }}</span>
                      </div>
                      <div class="a__right">
                          <icon name="contact" class="h-5 fill-gray-400 mr-5 ml-5" />
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div v-if="loading" class="processing-overlay">
          <div class="background"></div>
          <div class="loader">
              <svg width="200px" height="200px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;">
                  <circle cx="75" cy="50" fill="#ffffff" r="6.39718">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.875s"></animate>
                  </circle>
                  <circle cx="67.678" cy="67.678" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                  </circle>
                  <circle cx="50" cy="75" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.625s"></animate>
                  </circle>
                  <circle cx="32.322" cy="67.678" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                  </circle>
                  <circle cx="25" cy="50" fill="#ffffff" r="4.8">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.375s"></animate>
                  </circle>
                  <circle cx="32.322" cy="32.322" fill="#ffffff" r="4.80282">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                  </circle>
                  <circle cx="50" cy="25" fill="#ffffff" r="6.40282">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.125s"></animate>
                  </circle>
                  <circle cx="67.678" cy="32.322" fill="#ffffff" r="7.99718">
                      <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                  </circle>
              </svg>
          </div>
      </div>

  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import BarChart from '@/Shared/BarChart.vue'

const top_departments = [
  { name: 'Support', value: 30 },
  { name: 'Sales', value: 20 },
  { name: 'QA', value: 10 },
]

export default {
  metaInfo: { title: 'Dashboard' },
    components: {
        Head,
        Icon,
        Link,
        BarChart,
    },
  layout: Layout,
    props: {
        auth: Object,
        entries: Array,
        chart_line: Object,
        api_key: String,
        new_tickets: Number,
        pending_tickets: Number,
        assigned_tickets: Number,
        processing_tickets: Number,
        needreview_tickets: Number,
        revisiassets_tickets: Number,
        revisibrief_tickets: Number,
        onreview_tickets: Number,
        total_tickets: Number,
        un_assigned_tickets: Number,
        opened_tickets: Number,
        complete_tickets: Number,
        closed_tickets: Number,
        done_tickets: Number,
        first_response: Array,
        top_creators: Array,
        top_requester_creators: Array,
        last_response: Array,
        top_departments: Array,
        departements: Array,
        top_types: Array,
        total_customer: Number,
        total_contacts: Number,
    },
    data() {
        return {
            selectedDepartment: null,
            list_filter_department: [],
            tickets: window.appData?.tickets ?? [],
            errors: [],
            loading: false,
            firstResponse: [],
            lastResponse: [],
            months: [],
        }
    },
    mounted() {
        this.getDepartments();
    },
    computed: {
       canViewAssigned() {
           return this.auth.user.department_id === 3 || this.auth.user.role.slug === 'admin';
       },

    },
    mounted() {
        // Log the auth user object to the console
;
    },
    created() {
        for (let i = 0; i < this.first_response.length; i++) {
            if(i % 2 === 0){
                this.firstResponse = [...this.firstResponse, [this.first_response[i], this.first_response[i+1]]]
            }
        }
        for (let i = 0; i < this.last_response.length; i++) {
            if(i % 2 === 0){
                this.lastResponse = [...this.lastResponse, [this.last_response[i], this.last_response[i+1]]]
            }
        }

        this.months = this.chart_line.previousMonths.map( m =>{
            return { 'month': m, 'value': this.chart_line.months[m] ? ((this.chart_line.months[m] * 100)/this.chart_line.total)+'%': '0%' }
        })
    },
    methods: {
        goToLink(link){
            window.location.href = link;
        },
        getDepartments() {
            fetch('/departments/filter-list')
                .then(response => response.json())
                .then(data => {
                    this.list_filter_department = data;
                })
                .catch(error => {
;
                });
        },
        filterByDepartment() {
            // Logika filter tiket bisa di sini, contoh:
;

            // Bisa digunakan untuk trigger filter data, emit event, atau panggil method lain
            this.fetchTicketsByDepartment(this.selectedDepartment);
        },
        fetchTicketsByDepartment(departmentId) {
            // Optional: jika kamu mau reload data berdasarkan departmentId
        }
    },
}
</script>
